module.exports = __webpack_public_path__ + "assets/2.jpg?34eb94f7095b6b798d85e51badbfcf5b";